module.exports = __webpack_public_path__ + "static/media/sqlserver_manager_restart_server.0d9cb68e.png";